/* eslint-disable no-nested-ternary */
import React from 'react';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import Checkbox from '../../../../molecules/Checkbox';
import ErrorSvg from '../../assets/error.svg';
import {
  Container,
  Wrapper,
  Label,
  Astericks,
  Input,
  ErrorIcon,
  ErrorMessage,
} from '../styles/FormControl.styled';

const FormControl = ({
  id,
  type,
  name,
  label,
  placeholder,
  autoComplete,
  required,
  errorMessage,
  value,
  handleChange,
  hidden,
  layout,
  styles,
}) => (
  <Container
    className={`custom-form-control control-${name}`}
    hidden={hidden}
    styles={styles}
  >
    <Wrapper className="custom-form-control-wrapper" layout={layout}>
      <Label htmlFor={name} className="custom-form-control-label">
        {label}
        {required && <Astericks>*</Astericks>}
      </Label>
      {type === 'tel' ? (
        <PhoneInput
          containerClass="phone-input-container"
          placeholder={placeholder}
          inputProps={{
            name: 'phone',
          }}
          country="us"
          value={value}
          onChange={(_, __, e) => handleChange(e)}
        />
      ) : type === 'checkbox' ? (
        <Checkbox
          name={name}
          className="disclaimer-checkbox"
          checked={value}
          setChecked={handleChange}
        />
      ) : (
        <Input
          id={id}
          type={type}
          name={name}
          placeholder={placeholder}
          autoComplete={autoComplete}
          value={value}
          className={errorMessage ? 'error' : ''}
          onChange={e => handleChange(e)}
        />
      )}
      {errorMessage && type !== 'checkbox' && (
        <ErrorIcon className="error-icon" src={ErrorSvg} alt="Error Icon" />
      )}
    </Wrapper>
    {errorMessage && (
      <ErrorMessage
        className="error-message"
        dangerouslySetInnerHTML={{ __html: errorMessage }}
      />
    )}
  </Container>
);

export default FormControl;
